//create broadcast
export const CREATE_TEST_BROADCAST_REQUEST = "CREATE_TEST_BROADCAST_REQUEST";
export const CREATE_TEST_BROADCAST_RECEIVE = "CREATE_TEST_BROADCAST_RECEIVE";
export const CREATE_TEST_BROADCAST_FAILURE = "CREATE_TEST_BROADCAST_FAILURE";
export const RESET_CREATE_TEST_BROADCAST= "RESET_CREATE_TEST_BROADCAST";